import * as R from 'ramda';
import dayjs from 'dayjs'
import dayjsUtc from 'dayjs/plugin/utc'

import { dateOnlySlashesFormat } from 'App/services/DateService';

dayjs.extend(dayjsUtc)

const dateOrDashUtc = R.curry((path, data) => {
    const date = R.path(path, data);
    if (date) {
        return dayjs.utc(date).format(dateOnlySlashesFormat);
    }

    return '--';
});


export default dateOrDashUtc;
